(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────────────────
     SOCIAL PROOF TICKER CLASS & INIT (Global to the script block)
     ───────────────────────────────────────────────────────────────────────── */
  class PdpSocialProofTicker {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('.pdp-social-proof-ticker__track');
      this.items = Array.from(el.querySelectorAll('.pdp-social-proof-ticker__item'));
      if (this.items.length === 0) return;

      this.animation = el.dataset.animation;
      this.autoplay = el.dataset.autoplay === 'true';
      this.speed = parseInt(el.dataset.speed, 10) || 4000;
      this.pauseOnHover = el.dataset.pauseOnHover === 'true';
      this.swipeEnabled = el.dataset.swipeEnabled === 'true';

      this.currentIndex = 0;
      this.timer = null;
      this.typeInterval = null;
      this.isPaused = false;

      this.init();
    }

    init() {
      this.setupTypewriterInitial();
      
      if (this.autoplay) {
        this.startAutoplay();
        if (this.pauseOnHover) {
          this.el.addEventListener('mouseenter', () => this.pause());
          this.el.addEventListener('mouseleave', () => this.resume());
        }
      }

      if (this.swipeEnabled) {
        this.setupSwipe();
      }
    }

    setupTypewriterInitial() {
      if (this.animation === 'typewriter') {
        const activeItem = this.items[0];
        this.runTypewriter(activeItem);
      }
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => {
        if (!this.isPaused) {
          this.next();
        }
      }, this.speed);
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
    }

    pause() {
      this.isPaused = true;
    }

    resume() {
      this.isPaused = false;
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.items.length;
      this.goTo(nextIndex);
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
      this.goTo(prevIndex);
    }

    goTo(index) {
      if (index === this.currentIndex) return;

      const currentItem = this.items[this.currentIndex];
      const nextItem = this.items[index];

      if (this.typeInterval) {
        clearInterval(this.typeInterval);
        this.typeInterval = null;
      }

      currentItem.classList.remove('is-active');
      currentItem.classList.add('is-exiting');
      currentItem.setAttribute('aria-hidden', 'true');

      const transitionTime = this.animation === 'none' ? 0 : 450;

      setTimeout(() => {
        currentItem.classList.remove('is-exiting');
      }, transitionTime);

      nextItem.classList.add('is-active');
      nextItem.setAttribute('aria-hidden', 'false');

      if (this.animation === 'typewriter') {
        this.runTypewriter(nextItem);
      }

      this.currentIndex = index;
      
      if (this.autoplay && !this.isPaused) {
        this.startAutoplay();
      }
    }

    runTypewriter(item) {
      const textEl = item.querySelector('.pdp-social-proof-ticker__text');
      if (!textEl) return;
      const targetText = textEl.getAttribute('data-text-raw') || '';
      textEl.textContent = '';
      
      let charIdx = 0;
      this.typeInterval = setInterval(() => {
        if (charIdx < targetText.length) {
          textEl.textContent += targetText.charAt(charIdx);
          charIdx++;
        } else {
          clearInterval(this.typeInterval);
          this.typeInterval = null;
        }
      }, 35);
    }

    setupSwipe() {
      let startX = 0;
      let endX = 0;

      this.el.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      }, { passive: true });

      this.el.addEventListener('touchend', (e) => {
        endX = e.changedTouches[0].clientX;
        const diffX = startX - endX;
        const threshold = 40;

        if (Math.abs(diffX) > threshold) {
          if (diffX > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
      }, { passive: true });
    }
  }

  function initPdpTickers() {
    document.querySelectorAll('.pdp-social-proof-ticker').forEach(ticker => {
      if (!ticker.classList.contains('js-initialized')) {
        ticker.classList.add('js-initialized');
        new PdpSocialProofTicker(ticker);
      }
    });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     CORE SECTION INITIALIZER
     ───────────────────────────────────────────────────────────────────────── */
  function initProductSection(ROOT) {
    if (ROOT.classList.contains('pdp-js-initialized')) return;
    ROOT.classList.add('pdp-js-initialized');

    var sectionId     = ROOT.getAttribute('data-section-id');
    var thumbsEl      = ROOT.querySelector('[data-pdp-thumbs]');
    var galleryWrap   = ROOT.querySelector('[data-pdp-gallery-wrap]');
    var galleryEl     = ROOT.querySelector('[data-pdp-gallery]');
    var dotsEl        = ROOT.querySelector('[data-pdp-dots]');
    var zoomTapBtn    = ROOT.querySelector('[data-pdp-zoom-tap]');
    var lightbox      = document.getElementById('pdp-lightbox-' + sectionId);
    var lightboxImg   = lightbox  && lightbox.querySelector('[data-pdp-lightbox-img]');
    var stickyBar     = document.querySelector('[data-pdp-sticky]');
    var stickyAtcBtn  = document.querySelector('[data-pdp-sticky-atc]');
    var stickyPrice   = document.querySelector('[data-pdp-sticky-price]');
    var variantIdEl   = document.querySelector('[data-pdp-variant-id]');
    var priceEl       = document.querySelector('[data-pdp-price]');
    var compareEl     = document.querySelector('[data-pdp-compare]');
    var saveEl        = document.querySelector('[data-pdp-save]');
    var atcBtn        = document.querySelector('[data-pdp-atc]');
    var formQtyEl     = document.querySelector('[data-pdp-form-qty]');
    var qtyInput      = document.querySelector('[data-pdp-qty]');
    var variantSelected = false;

    /* ── Parse data from JSON script blocks ── */
    var variants      = [];
    var mediaMap      = {};
    try {
      var varJson = ROOT.querySelector('[data-pdp-json]') || 
                    document.querySelector('[data-section-id="' + sectionId + '"] [data-pdp-json]') || 
                    document.querySelector('[data-pdp-json]');
      if (varJson) variants = JSON.parse(varJson.textContent);
    } catch (e) {}
    try {
      var mmJson = ROOT.querySelector('[data-pdp-media-map]') || 
                   document.querySelector('[data-section-id="' + sectionId + '"] [data-pdp-media-map]') || 
                   document.querySelector('[data-pdp-media-map]');
      if (mmJson) mediaMap = JSON.parse(mmJson.textContent);
    } catch (e) {}

    var ZOOM_ENABLED  = galleryWrap && galleryWrap.getAttribute('data-zoom-enabled') === 'true';
    var ZOOM_LEVEL    = parseFloat((galleryWrap && galleryWrap.getAttribute('data-zoom-level')) || '1.8');
    var currentIndex  = 0;
    var mediaCount    = (thumbsEl && thumbsEl.querySelectorAll('.pdp__thumb').length) || 
                        (galleryEl && galleryEl.querySelectorAll('.pdp__slide').length) || 0;
    var cachedWidth   = 0;

    function updateCachedWidth() {
      if (!galleryEl || !galleryEl.isConnected) {
        window.removeEventListener('resize', updateCachedWidth);
        return;
      }
      cachedWidth = galleryEl.clientWidth;
    }
    updateCachedWidth();
    window.addEventListener('resize', updateCachedWidth);

    /* ── CORE: Switch active slide by index ── */
    function updateIndicators(idx) {
      /* Thumbnails */
      if (thumbsEl) {
        var thumbs = thumbsEl.querySelectorAll('.pdp__thumb');
        thumbs.forEach(function (t, i) {
          var active = i === idx;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-pressed', String(active));
        });
        /* Scroll active thumb into view */
        var activeThumb = thumbs[idx];
        if (activeThumb) {
          var isMobile = window.innerWidth <= 900;
          activeThumb.scrollIntoView({ behavior: isMobile ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }

      /* Mobile dots */
      if (dotsEl) {
        dotsEl.querySelectorAll('.pdp__mobile-dot').forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === idx);
        });
      }

      /* Mobile numbers badge */
      var badge = galleryWrap ? galleryWrap.querySelector('[data-pdp-numbers-badge]') : null;
      if (badge) {
        badge.textContent = (idx + 1) + ' / ' + mediaCount;
      }
    }

    function goToSlide(idx) {
      if (mediaCount <= 0) return;
      if (idx < 0)           idx = mediaCount - 1;
      if (idx >= mediaCount) idx = 0;
      currentIndex = idx;

      /* Slides */
      var slides = galleryEl ? galleryEl.querySelectorAll('.pdp__slide') : [];
      slides.forEach(function (slide, i) {
        var active = i === idx;
        slide.classList.toggle('is-active', active);
        
        // Control video play/pause
        var video = slide.querySelector('[data-pdp-video]');
        if (video) {
          if (active) {
            video.play().catch(function() {});
          } else {
            video.pause();
          }
        }
      });

      updateIndicators(idx);

      /* Move transform-based slide track (mobile slider) */
      var mobileStyle = ROOT.getAttribute('data-mobile-gallery-style') || 'slider_dots';
      var isMobile = window.innerWidth <= 900;
      var isSlider = mobileStyle === 'slider_dots' || mobileStyle === 'slider_numbers' || mobileStyle === 'thumbnails';
      if (isMobile && isSlider && slideTrack) {
        slideTrack.classList.remove('is-dragging');
        slideTrack.style.transform = 'translateX(' + (-idx * 100) + '%)';
      }
    }

    /* ── THUMBNAIL CLICK ENGINE ── */
    function bindThumbs() {
      if (!thumbsEl) return;
      thumbsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.pdp__thumb');
        if (!btn) return;
        var idx = parseInt(btn.getAttribute('data-thumb-index'), 10);
        if (!isNaN(idx)) goToSlide(idx);
      });
    }

    /* ── HOVER ZOOM — Mode 1 (cursor-tracking transform-origin) ── */
    function bindHoverZoom() {
      if (!galleryWrap || !ZOOM_ENABLED) return;

      galleryWrap.addEventListener('mousemove', function (e) {
        var rect  = galleryWrap.getBoundingClientRect();
        var xPct  = ((e.clientX - rect.left) / rect.width  * 100).toFixed(2) + '%';
        var yPct  = ((e.clientY - rect.top)  / rect.height * 100).toFixed(2) + '%';
        var img   = galleryWrap.querySelector('[data-pdp-img]');
        if (img) {
          img.style.setProperty('--zoom-x', xPct);
          img.style.setProperty('--zoom-y', yPct);
          img.style.transformOrigin = xPct + ' ' + yPct;
        }
      });

      galleryWrap.addEventListener('mouseleave', function () {
        var img   = galleryWrap.querySelector('[data-pdp-img]');
        if (img) {
          img.style.setProperty('--zoom-x', '50%');
          img.style.setProperty('--zoom-y', '50%');
          img.style.transformOrigin = '50% 50%';
        }
      });

      /* Show the tap icon on hover */
      galleryWrap.addEventListener('mouseenter', function () {
        if (zoomTapBtn) zoomTapBtn.style.opacity = '0';
      });
    }

    /* ── TRANSFORM-BASED MOBILE SLIDER ── */
    var slideTrack = null;
    var mobileStyleGlobal = ROOT.getAttribute('data-mobile-gallery-style') || 'slider_dots';
    var isSliderGlobal = mobileStyleGlobal === 'slider_dots' || mobileStyleGlobal === 'slider_numbers' || mobileStyleGlobal === 'thumbnails';

    function initMobileSlider() {
      if (!galleryEl || !isSliderGlobal) return;
      if (window.innerWidth > 900) return;
      if (slideTrack) return; /* Already initialised */

      /* Create the track element */
      slideTrack = document.createElement('div');
      slideTrack.className = 'pdp__slide-track';

      /* Move all existing slides into the track */
      var slides = Array.prototype.slice.call(galleryEl.querySelectorAll('.pdp__slide'));
      slides.forEach(function (slide) {
        slideTrack.appendChild(slide);
      });
      galleryEl.appendChild(slideTrack);

      /* Position track at index 0 immediately (no transition) */
      slideTrack.style.transition = 'none';
      slideTrack.style.transform = 'translateX(0%)';
      /* Force reflow so 'none' transition is applied, then restore */
      void slideTrack.offsetWidth;
      slideTrack.style.transition = '';
    }

    /* ── SWIPE GESTURE — transform drag + release snap ── */
    function bindSwipe() {
      if (!galleryWrap) return;
      var touchStartX = 0;
      var touchStartY = 0;
      var dragDeltaX = 0;
      var isHoriz = null;
      var isTouchActive = false;

      galleryWrap.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        dragDeltaX = 0;
        isHoriz = null;
        isTouchActive = true;
      }, { passive: true });

      galleryWrap.addEventListener('touchmove', function (e) {
        if (!isTouchActive) return;
        var dx = e.touches[0].clientX - touchStartX;
        var dy = e.touches[0].clientY - touchStartY;

        /* Determine axis on first 5px of movement */
        if (isHoriz === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
          isHoriz = Math.abs(dx) >= Math.abs(dy);
        }

        var isMobile = window.innerWidth <= 900;

        if (isMobile && isSliderGlobal && slideTrack) {
          if (isHoriz === true) {
            e.preventDefault(); /* Stop page scroll while swiping gallery */
            dragDeltaX = dx;
            /* Live drag feedback: shift track by drag amount */
            var pct = (-currentIndex * 100) + (dx / galleryEl.clientWidth * 100);
            slideTrack.classList.add('is-dragging');
            slideTrack.style.transform = 'translateX(' + pct + '%)';
          }
        } else if (isMobile && isHoriz) {
          e.preventDefault();
        }
      }, { passive: false });

      galleryWrap.addEventListener('touchend', function (e) {
        if (!isTouchActive) return;
        isTouchActive = false;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        var isMobile = window.innerWidth <= 900;

        if (isMobile && isSliderGlobal && slideTrack) {
          slideTrack.classList.remove('is-dragging');
          var threshold = Math.min(galleryEl.clientWidth * 0.2, 60);
          if (Math.abs(dx) > threshold) {
            /* Swipe detected — go to next/prev */
            goToSlide(dx < 0 ? currentIndex + 1 : currentIndex - 1);
          } else if (Math.abs(dx) < 8 && Math.abs(dy) < 8) {
            /* Tap — open lightbox */
            openLightbox(currentIndex);
          } else {
            /* Snap back to current slide */
            slideTrack.style.transform = 'translateX(' + (-currentIndex * 100) + '%)';
          }
        } else if (!isSliderGlobal || !isMobile) {
          /* Desktop or stacked/collage — programmatic navigation */
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
            goToSlide(dx < 0 ? currentIndex + 1 : currentIndex - 1);
          } else if (Math.abs(dx) < 8 && Math.abs(dy) < 8) {
            openLightbox(currentIndex);
          }
        }
        isHoriz = null;
      }, { passive: true });
    }

    function bindMobileDots() {
      if (!dotsEl) return;
      dotsEl.addEventListener('click', function (e) {
        var dot = e.target.closest('.pdp__mobile-dot');
        if (!dot) return;
        var idx = parseInt(dot.getAttribute('data-dot'), 10);
        if (!isNaN(idx)) goToSlide(idx);
      });
    }

    /* ── LIGHTBOX — Mode 2 (tap / click to fullscreen) ── */
    function getHighResSrc(idx) {
      var mediaId = '';
      var slide = ROOT.querySelector('[data-slide-index="' + idx + '"]');
      if (slide) {
        mediaId = slide.getAttribute('data-media-id');
      }
      if (!mediaId && thumbsEl) {
        var thumb = thumbsEl.querySelector('[data-thumb-index="' + idx + '"]');
        if (thumb) {
          mediaId = thumb.getAttribute('data-media-id');
        }
      }
      if (mediaId && mediaMap[mediaId]) {
        var src = mediaMap[mediaId].src_hq || mediaMap[mediaId].src;
        if (src) return src;
      }
      // Fallback: get the image source directly from the slide image
      if (slide) {
        var img = slide.querySelector('[data-pdp-img]');
        if (img && img.src) return img.src;
      }
      return '';
    }

    function openLightbox(idx) {
      if (!lightbox || !lightboxImg) return;
      var src = getHighResSrc(idx);
      if (!src) {
        // Ultimate fallback: first slide's image source
        var fallbackImg = ROOT.querySelector('[data-pdp-img]');
        if (fallbackImg) src = fallbackImg.src;
      }
      lightboxImg.src = src;

      lightboxImg.alt = (function () {
        var mediaId = '';
        var slide = ROOT.querySelector('[data-slide-index="' + idx + '"]');
        if (slide) {
          mediaId = slide.getAttribute('data-media-id');
          var img = slide.querySelector('[data-pdp-img]');
          if (img && img.alt) return img.alt;
        }
        if (!mediaId && thumbsEl) {
          var thumb = thumbsEl.querySelector('[data-thumb-index="' + idx + '"]');
          if (thumb) {
            mediaId = thumb.getAttribute('data-media-id');
          }
        }
        if (mediaId && mediaMap[mediaId]) {
          return mediaMap[mediaId].alt || '';
        }
        return '';
      })();

      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      lightbox._currentIdx = idx;
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function lightboxNav(dir) {
      if (!lightbox) return;
      var idx = ((lightbox._currentIdx || 0) + dir + mediaCount) % mediaCount;
      openLightbox(idx);
      goToSlide(idx);
    }

    function bindLightbox() {
      if (!lightbox) return;
      var closeBtn = lightbox.querySelector('[data-pdp-lightbox-close]');
      var prevBtn  = lightbox.querySelector('[data-pdp-lightbox-prev]');
      var nextBtn  = lightbox.querySelector('[data-pdp-lightbox-next]');

      if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
      if (prevBtn)  prevBtn.addEventListener('click',  function () { lightboxNav(-1); });
      if (nextBtn)  nextBtn.addEventListener('click',  function () { lightboxNav(1);  });

      /* Close on backdrop click */
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });

      /* Keyboard nav with auto-removal helper */
      var handleKeyDown = function (e) {
        if (!lightbox || !lightbox.isConnected) {
          document.removeEventListener('keydown', handleKeyDown);
          return;
        }
        if (!lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape')    closeLightbox();
        if (e.key === 'ArrowLeft') lightboxNav(-1);
        if (e.key === 'ArrowRight') lightboxNav(1);
      };
      document.addEventListener('keydown', handleKeyDown);

      /* Desktop: click on gallery image to open lightbox */
      if (galleryWrap) {
        galleryWrap.addEventListener('click', function (e) {
          /* On desktop, only open lightbox if zoom is disabled */
          if (!ZOOM_ENABLED) {
            openLightbox(currentIndex);
          }
        });
      }

      /* Mobile tap icon */
      if (zoomTapBtn) {
        zoomTapBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          openLightbox(currentIndex);
        });
      }

      /* Mobile swipe gestures for lightbox */
      var startX = 0;
      var startY = 0;
      lightbox.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      lightbox.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          lightboxNav(dx < 0 ? 1 : -1);
        }
      }, { passive: true });
    }

    /* ── VARIANT ENGINE — pill selection → media + price update ── */
    function getSelectedOptions() {
      var opts = {};
      
      // Check radio pills
      ROOT.querySelectorAll('.pdp__pill-input:checked').forEach(function (input) {
        var pos = parseInt(input.getAttribute('data-option-position'), 10);
        if (!isNaN(pos)) opts[pos] = input.value;
      });

      // Check select dropdowns
      ROOT.querySelectorAll('.pdp__option-select').forEach(function (select) {
        var pos = parseInt(select.getAttribute('data-option-position'), 10);
        if (!isNaN(pos)) opts[pos] = select.value;
      });

      return opts;
    }

    function findVariant(selectedOpts) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) {
          return selectedOpts[i + 1] === val;
        });
      });
    }

    function updateVariantUI(variant) {
      if (!variant) return;

      /* Update hidden variant ID */
      if (variantIdEl) variantIdEl.value = variant.id;

      /* Update prices */
      if (priceEl) priceEl.textContent = window.LavikaFormatMoney ? window.LavikaFormatMoney(variant.price) : ('\u20B9' + Math.round(variant.price / 100));
      if (stickyPrice) stickyPrice.textContent = priceEl ? priceEl.textContent : '';

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.style.display = onSale ? '' : 'none';
        if (onSale) compareEl.textContent = window.LavikaFormatMoney ? window.LavikaFormatMoney(variant.compare_at_price) : ('\u20B9' + Math.round(variant.compare_at_price / 100));
      }
      if (saveEl) {
        saveEl.style.display = onSale ? '' : 'none';
        if (onSale) saveEl.textContent = 'You save ' + (window.LavikaFormatMoney ? window.LavikaFormatMoney(variant.compare_at_price - variant.price) : ('\u20B9' + Math.round((variant.compare_at_price - variant.price) / 100)));
      }

      /* Update ATC button state */
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        var atcText = atcBtn.querySelector('.pdp__atc-text');
        if (atcText) {
          atcText.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
        } else {
          atcBtn.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
        }
      }

      /* Update selected option label */
      ROOT.querySelectorAll('.pdp__pill-input:checked').forEach(function (input) {
        var optName = input.getAttribute('name').replace('options[', '').replace(']', '');
        var labelEl = ROOT.querySelector('[data-selected-option="' + optName + '"]');
        if (labelEl) labelEl.textContent = input.value;
      });

      /* Switch media to variant's featured image */
      if (variant.featured_media && variant.featured_media.id) {
        var mediaId = String(variant.featured_media.id);
        var targetIdx = -1;
        if (thumbsEl) {
          var thumbs = thumbsEl.querySelectorAll('.pdp__thumb');
          thumbs.forEach(function (thumb, i) {
            if (thumb.getAttribute('data-media-id') === mediaId) {
              targetIdx = i;
            }
          });
        }
        if (targetIdx >= 0) goToSlide(targetIdx);
      }
    }

    function bindVariants() {
      ROOT.addEventListener('change', function (e) {
        if (e.target.classList.contains('pdp__pill-input') || e.target.classList.contains('pdp__option-select')) {
          variantSelected = true;
          var opts    = getSelectedOptions();
          var variant = findVariant(opts);
          if (variant) updateVariantUI(variant);
        }
      });

      // Mark as selected on pill click (in case of re-select)
      ROOT.querySelectorAll('.pdp__pill-input').forEach(function (pill) {
        pill.addEventListener('click', function() {
          variantSelected = true;
        });
      });
    }

    /* ── QUANTITY STEPPER (sync between PDP form and sticky bar) ── */
    function bindQtyStepper() {
      ROOT.addEventListener('click', function (e) {
        var btn = e.target.closest('.qty-stepper__btn');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var dir = btn.getAttribute('data-step') === 'inc' ? 1 : -1;
        if (qtyInput) {
          var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + dir);
          qtyInput.value = val;
          if (formQtyEl) formQtyEl.value = val;
        }
      });
    }

    /* ── STICKY ATC — shows after scrolling past the main ATC button ── */
    function bindStickyBar() {
      if (!stickyBar || !atcBtn) return;

      var io = new IntersectionObserver(function (entries) {
        /* Hide sticky when ANY part of the ATC button is visible (threshold:0) */
        var visible = entries[0].isIntersecting;
        stickyBar.classList.toggle('is-visible', !visible);
      }, { threshold: 0, rootMargin: '0px 0px -10px 0px' });
      io.observe(atcBtn);

      /* Sticky ATC button → submit main form */
      if (stickyAtcBtn) {
        stickyAtcBtn.addEventListener('click', function (e) {
          var productHasVariants = ROOT.querySelector('.pdp__variants');
          if (productHasVariants) {
            if (!variantSelected) {
              e.preventDefault();
              var variantPicker = ROOT.querySelector('.pdp__block-variant-picker');
              if (variantPicker) {
                // Scroll to the variant picker block smoothly
                variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
                
                // Apply focus highlight
                variantPicker.classList.add('flash-highlight');
                setTimeout(function() {
                  variantPicker.classList.remove('flash-highlight');
                }, 1500);
                
                // Trigger a Toast Notification
                if (window.LavikaToast) {
                  window.LavikaToast('Please select your variant options first!', 'error');
                }
              }
              return;
            }
          }

          var form = document.getElementById('product-form-' + sectionId);
          if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }
    }

    /* ── MOBILE: show expand icon on gallery hover/touch ── */
    function bindMobileZoomIcon() {
      if (!galleryWrap || !zoomTapBtn) return;
      galleryWrap.addEventListener('touchstart', function () {
        zoomTapBtn.style.opacity = '1';
      }, { passive: true });
    }

    /* ── RECOMMENDATIONS ASYNC LOAD ── */
    function bindRecommendations() {
      var recContainer = ROOT.querySelector('#recommendations-' + sectionId) || document.getElementById('recommendations-' + sectionId);
      if (!recContainer) return;

      var observer = new IntersectionObserver(function(entries, observer) {
        if (entries[0].isIntersecting) {
          observer.unobserve(recContainer);
          var url = recContainer.getAttribute('data-url');
          if (!url) return;

          // Prevent cache hitting so editor settings changes show immediately
          if (window.Shopify && window.Shopify.designMode) {
            url += '&_t=' + Date.now();
          }

          fetch(url)
            .then(function(response) { return response.text(); })
            .then(function(html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var recommendedContainer = doc.getElementById('recommendations-' + sectionId);
              if (recommendedContainer && recommendedContainer.querySelector('.product-recommendations__grid')) {
                recContainer.innerHTML = recommendedContainer.innerHTML;
                
                // Re-initialize dynamic behaviors on the cards if needed
                if (window.initializeWishlist) {
                  window.initializeWishlist(recContainer);
                }
                if (window.initializeCountdowns) {
                  window.initializeCountdowns(recContainer);
                }
              }
            })
            .catch(function(err) {
              console.error('Error loading recommendations:', err);
            });
        }
      }, { rootMargin: '0px 0px 400px 0px' });

      observer.observe(recContainer);
    }

    /* ── INITIALIZE REGISTERED CONTROLS ── */
    bindThumbs();
    bindHoverZoom();
    bindSwipe();
    bindLightbox();
    bindVariants();
    bindQtyStepper();
    bindStickyBar();
    bindMobileZoomIcon();
    bindMobileDots();
    bindRecommendations();

    /* Init mobile slider FIRST so slideTrack exists before goToSlide(0) */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        /* Layout is now computed */
        if (galleryEl) cachedWidth = galleryEl.clientWidth;
        initMobileSlider(); /* Create track & move slides into it */
        goToSlide(0);       /* Set initial position (no animation) */
      });
    });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     PRODUCT VIDEO REELS ENGINE
     ───────────────────────────────────────────────────────────────────────── */
  function PdpVideoReels(ROOT) {
    if (ROOT.classList.contains('js-reels-initialized')) return;
    ROOT.classList.add('js-reels-initialized');

    var track = ROOT.querySelector('[data-reels-track]');
    var slides = ROOT.querySelectorAll('.pdp-video-reels__slide');
    var cards = ROOT.querySelectorAll('[data-reel-card]');
    var prevBtn = ROOT.querySelector('[data-reels-arrow-prev]');
    var nextBtn = ROOT.querySelector('[data-reels-arrow-next]');
    if (!track || slides.length === 0) return;

    var currentIndex = 0;
    var totalSlides = slides.length;
    var isGlobalMuted = true; // Default mute state

    // Touch Swipe properties
    var touchStartX = 0;
    var touchStartY = 0;
    var isDragging = false;

    function getCardWidth() {
      if (slides.length === 0) return 0;
      return slides[0].offsetWidth;
    }

    function getGap() {
      if (slides.length <= 1) return 0;
      var style = window.getComputedStyle(track);
      var gap = parseInt(style.gap || '16', 10);
      return gap;
    }

    function updateNavButtons() {
      var isMobile = window.innerWidth <= 768;
      if (isMobile) return;

      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= totalSlides - 3;
    }

    function goToSlide(idx) {
      var isMobile = window.innerWidth <= 768;
      var cardWidth = getCardWidth();
      var gap = getGap();

      var maxIndex = totalSlides - 1;
      if (!isMobile) {
        maxIndex = Math.max(0, totalSlides - 3);
      }

      if (idx < 0) idx = 0;
      if (idx > maxIndex) idx = maxIndex;

      currentIndex = idx;

      var offset = 0;
      if (isMobile) {
        // Centering calculation on mobile: (viewport - cardWidth) / 2 - idx * (cardWidth + gap)
        var viewport = ROOT.querySelector('.pdp-video-reels__viewport');
        var viewportWidth = viewport ? viewport.clientWidth : window.innerWidth;
        offset = (viewportWidth / 2) - (cardWidth / 2) - idx * (cardWidth + gap);
      } else {
        // Start alignment on desktop: -idx * (cardWidth + gap)
        offset = -idx * (cardWidth + gap);
      }

      track.style.transform = 'translateX(' + offset + 'px)';

      // Mark active slide
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === currentIndex);
      });

      // Update arrow button disabled states
      updateNavButtons();

      // Play the video inside the active card (if section is visible), pause others
      manageVideoPlayback();
    }

    // Touch events for mobile swipe
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isDragging = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      isDragging = false;

      var touchEndX = e.changedTouches[0].clientX;
      var touchEndY = e.changedTouches[0].clientY;
      var diffX = touchStartX - touchEndX;
      var diffY = touchStartY - touchEndY;

      // Only respond if swipe is horizontal and meets threshold
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 45) {
        if (diffX > 0) {
          goToSlide(currentIndex + 1);
        } else {
          goToSlide(currentIndex - 1);
        }
      }
    }, { passive: true });

    // Desktop arrow clicks
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToSlide(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToSlide(currentIndex + 1);
      });
    }

    // Resize handling to update alignment
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        goToSlide(currentIndex);
      }, 100);
    });

    // Mute/Unmute audio toggler on tap/click
    cards.forEach(function (card, index) {
      var video = card.querySelector('[data-reel-video]');
      if (!video) return;

      // Lazy load video if intersecting
      var lazyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            lazyObserver.unobserve(video);
            if (!video.src && video.getAttribute('src')) {
              video.load();
            }
          }
        });
      });
      lazyObserver.observe(video);

      // Handle card click
      card.addEventListener('click', function (e) {
        // Toggle sound state
        isGlobalMuted = !isGlobalMuted;
        
        // Update all videos sound states
        cards.forEach(function (c) {
          var v = c.querySelector('[data-reel-video]');
          var m = c.querySelector('[data-reel-mute-btn]');
          if (v) {
            v.muted = isGlobalMuted;
          }
          if (m) {
            var mutedIcon = m.querySelector('.is-muted');
            var unmutedIcon = m.querySelector('.is-unmuted');
            if (mutedIcon && unmutedIcon) {
              mutedIcon.style.display = isGlobalMuted ? 'block' : 'none';
              unmutedIcon.style.display = isGlobalMuted ? 'none' : 'block';
            }
          }
        });
      });
    });

    // IntersectionObserver to pause/play based on active state + section visibility
    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        manageVideoPlayback();
      });
    }, { threshold: 0.2 });
    sectionObserver.observe(ROOT);

    function manageVideoPlayback() {
      // Check if section itself is visible in viewport
      var rect = ROOT.getBoundingClientRect();
      var isVisible = rect.top < window.innerHeight && rect.bottom > 0;

      cards.forEach(function (card, i) {
        var video = card.querySelector('[data-reel-video]');
        if (!video) return;

        if (isVisible && i === currentIndex) {
          // Play active video
          video.muted = isGlobalMuted;
          video.play().catch(function () {});
        } else {
          // Pause all other videos
          video.pause();
        }
      });
    }

    // Set initial layout slide position
    setTimeout(function () {
      goToSlide(0);
    }, 100);
  }

  function initVideoReels(scopedEl) {
    if (scopedEl) {
      PdpVideoReels(scopedEl);
      return;
    }
    document.querySelectorAll('[data-pdp-video-reels]').forEach(function (el) {
      PdpVideoReels(el);
    });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     LOADER LOGIC
     ───────────────────────────────────────────────────────────────────────── */
  function initAll() {
    document.querySelectorAll('[data-section-type="product"]').forEach(function (section) {
      initProductSection(section);
    });
    initPdpTickers();
    initVideoReels();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    // Re-initialize product page logic for reloaded section in Theme Editor
    var section = document.querySelector('[data-section-id="' + e.detail.sectionId + '"][data-section-type="product"]');
    if (section) {
      initProductSection(section);
    }
    var reelsSection = document.querySelector('[data-section-id="' + e.detail.sectionId + '"][data-pdp-video-reels]');
    if (reelsSection) {
      initVideoReels(reelsSection);
    }
    initPdpTickers();
  });

})();
